<template>
    <el-scrollbar class="index-data">
        <div class="content-analysis">
            <div class="analysis-item" v-for="item in coreData" :key="item.ref">
                <div class="item-header">
                    <span>{{ item.label }}</span>

                    <el-popover popper-class="dark-popover" placement="top" width="200" trigger="hover" :content="item.tip">
                        <i class="el-icon-question" slot="reference" v-if="!!item.tip"></i>
                    </el-popover>
                </div>

                <div :class="['item-value', { down: item.count < 0 }]">
                    {{ item.count }}
                </div>

                <div class="item-chart" :ref="item.ref"></div>

                <div class="item-trend">周环比{{ item.trend }}%</div>
            </div>
        </div>

        <div class="content-detail">
            <div class="content-detail_header">
                <div class="header-label">详细数据</div>

                <div class="header-operate">
                    <div class="header-switch">
                        <el-switch v-model="expand" active-color="#2a55e5" inactive-color="#dcdfe6"> </el-switch>
                        <span>展开次级数据</span>
                    </div>

                    <el-button class="header-button" size="mini" disabled>下载数据</el-button>
                </div>
            </div>

            <div class="content-detail_table">
                <el-table
                    :data="tableData"
                    :key="tableKey"
                    style="
                            width: 100%;
                            flex: 1;
                            border-radius: 4px;
                        "
                    size="medium"
                    :header-cell-style="{
                        fontWeight: 'normal',
                        color: '#333',
                        background: '#f5f7fa',
                    }"
                    :border="false"
                    :cell-style="{ fontSize: '12px', color: '#333' }"
                    height="100%"
                >
                    <el-table-column prop="date" label="日期" width="150"> </el-table-column>
                    <el-table-column prop="home_person" label="主页访问人数" width="150"> </el-table-column>
                    <el-table-column prop="home_count" label="主页访问次数" width="150"> </el-table-column>

                    <el-table-column label="企业信息用户点击量" v-if="expand" :key="'company-1'">
                        <el-table-column prop="company_sum_click" label="总点击量"></el-table-column>
                        <el-table-column prop="company_iphone" label="联系电话"></el-table-column>
                        <el-table-column prop="company_time" label="营业时间"></el-table-column>
                    </el-table-column>

                    <el-table-column prop="company_click" label="企业信息用户点击量" v-else :key="'company-2'"> </el-table-column>
                </el-table>
            </div>
        </div>
    </el-scrollbar>
</template>

<script>
import indexDataJson from "@/utils/training-data/index-data.json";

export default {
    name: "IndexData",
    data() {
        return {
            tableData: indexDataJson[0].tableData,
            coreData: indexDataJson[0].coreData,
            expand: false,
            tableKey: 1,
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.setChart();
        });
    },
    watch: {
        expand(newVal) {
            if (!newVal) {
                this.tableKey++;
            }
        },
    },
    methods: {
        setLineChart(ref, data) {
            const chart = this.$echarts.init(ref);

            const options = {
                grid: {
                    top: 1,
                    left: 0,
                    bottom: 1,
                    right: 0,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false, // 避免额外间隙
                    data: data.x,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                    },
                },
                yAxis: {
                    type: "value",
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                    },
                },
                series: [
                    {
                        data: data.y,
                        type: "line",
                        showSymbol: false,
                        smooth: true,
                        lineStyle: {
                            color: "#3b62e7",
                        },
                        areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "#dee2fa", // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: "#ffffff", // 100% 处的颜色
                                    },
                                ],
                                global: false, // 缺省为 false
                            },
                        },
                    },
                ],
            };

            chart.setOption(options);
        },

        setChart() {
            this.coreData.forEach((item, index) => {
                if (!this.$refs[item.ref][0]) return;
                const data = this.coreData[index].data;

                this.setLineChart(this.$refs[item.ref][0], data);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.index-data {
    margin-top: 16px;
    width: 100%;
    height: calc(100% - 16px);
    box-sizing: border-box;

    ::v-deep .el-scrollbar__wrap {
        margin: 0 !important;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .content-analysis {
        background-color: #ffffff;
        border-radius: 12px;
        margin-bottom: 16px;
        padding: 24px 24px 16px;
        display: flex;
        gap: 16px;

        .analysis-item {
            width: 274px;
            height: 180px;
            padding: 16px;
            border: 1px solid #1618230f;
            border-radius: 4px;
            box-sizing: border-box;

            .item-header {
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #666666;
                gap: 4px;

                .el-icon-question {
                    color: #999999;
                    cursor: pointer;
                }
            }

            .item-value {
                height: 32px;
                // background-color: red;
                margin-top: 12px;
                font-weight: 600;
                font-size: 30px;
                display: flex;
                align-items: center;

                // &.down {
                //     font-size: 14px;
                //     color: #999999;
                //     font-weight: 500;
                // }
            }

            .item-chart {
                // background-color: blue;
                // border: 1px solid rgba(0, 0, 0, 0.1);
                margin-top: 12px;
                height: 48px;
            }

            .item-trend {
                margin-top: 12px;
                display: flex;
                align-items: center;
                gap: 4px;

                color: #999999;

                .el-icon-caret-top {
                    color: #7aca53;
                }
            }
        }
    }

    .content-detail {
        border-radius: 12px;
        background-color: #ffffff;
        color: #333333;
        padding-bottom: 20px;
        margin-bottom: 20px;

        &_header {
            padding: 20px 32px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;

            .header-operate {
                display: flex;
                align-items: center;
                gap: 20px;

                .header-switch {
                    display: block;
                    height: 20px;
                    line-height: 20px;

                    span {
                        margin-left: 3px;
                    }
                }
            }
        }

        &_table {
            margin-bottom: 20px;
        }
    }
}
</style>
